import { Platform } from '@angular/cdk/platform';
import { DOCUMENT } from '@angular/common';
import { Component, Inject, Renderer2 } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControlBase } from '@leandredev/common-ng16/form';
import { form } from '@leandredev/adaptivai-ng16-lib';
import { filter } from 'rxjs';

import { SplashScreenService } from '../@fury/services/splash-screen.service';
import { ThemeService } from '../@fury/services/theme.service';
import { AppVersion } from './AppVersion';
import { DataService } from './dataService/dataService.service';
import { SignInJwtService } from './dataService/signIn-jwt.service';
import { SidenavService } from './layout/sidenav/sidenav.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  hasBeenConnected: boolean;

  constructor(
    protected dataService: DataService,
    signInJwtService: SignInJwtService,
    private sidenavService: SidenavService,
    private iconRegistry: MatIconRegistry,
    private renderer: Renderer2,
    private themeService: ThemeService,
    @Inject(DOCUMENT) private document: Document,
    private platform: Platform,
    private route: ActivatedRoute,
    private router: Router,
    private splashScreenService: SplashScreenService
  ) {
    FormControlBase.classes = form;

    console.info(`%c Version: ${AppVersion.appVersion}`, 'background:#ff0000;color:#FFFFFF;font-size:50px');

    this.route.queryParamMap
      .pipe(filter((queryParamMap) => queryParamMap.has('style')))
      .subscribe((queryParamMap) => this.themeService.setStyle(queryParamMap.get('style')));

    this.iconRegistry.setDefaultFontSetClass('material-icons-outlined');

    this.themeService.theme$.subscribe((theme) => {
      if (theme[0]) {
        this.renderer.removeClass(this.document.body, theme[0]);
      }

      this.renderer.addClass(this.document.body, theme[1]);
    });

    if (this.platform.BLINK) {
      this.renderer.addClass(this.document.body, 'is-blink');
    }

    this.sidenavService.initNavigationWithData();

    signInJwtService.connectedObs.subscribe({
      next: (result) => {
        if (result && !this.hasBeenConnected) {
          this.hasBeenConnected = true;
        } else if (!result && this.hasBeenConnected) {
          this.hasBeenConnected = false;
          this.router.navigate(['login']).catch((error) => {
            console.warn(error);
          });
        }
      },
      error: (err) => {
        console.warn(err);
      }
    });

    // this.userMessagesService.messagesObs.subscribe({
    //   next: (message) => {
    //     console.warn('messagesObs', message);
    //   },
    //   error: (err) => {
    //     console.warn('messagesObs err', err);
    //   }
    // });
  }
}
